import React, { useState } from "react";
import { Button } from "../../../../../shadcn/components/ui/button";
import { getBidderByUuid, updateBidderForEvent } from "services";
interface NITermsAndConditionsProps {
  bidderUuid: any;
  init: any;
  bidder: any;
  activeStep: number;
  setActiveStep: any;
  outerNextStep?: string | null;
}

export default function NITermsAndConditions({
  bidderUuid,
  init,
  bidder,
  activeStep,
  setActiveStep,
  outerNextStep = null,
}: NITermsAndConditionsProps) {
  const [loading, setLoading] = useState(false);
  const termsList = [
    "I/We have gone through the Property Details Section, including the Schedule of Property, as mentioned in the Auction Notice.",
    "I/We have reviewed the Auction Details Section, including Reserve Price, Auction Timing, and EMD Schedule, as published in the Auction Notice.",
    "I/We have noted the Seller/Lender and Auctioneer Details, as disclosed in the Auction Notice and tender form.",
    "I/We have filled the Bidder Information Section, and in case of joint participation, submitted the Joint Declaration and relevant details.",
    "I/We have carefully entered and cross-verified the EMD Payment Details and attached the necessary proof as required.",
    "I/We have understood and agree to the Bid Submission Terms, including all disclaimers and declarations made therein.",
    "I/We have read and understood the Payment Terms under SARFAESI Act, including EMD forfeiture conditions and payment timelines.",
    "I/We have read, understood, and agreed to the General Terms and Conditions for e-Auction, including legal framework, bidder eligibility, and post-auction responsibilities.",
    "I/We have referred to and understood the Definitions related to SARFAESI-based auctions as applicable in this context.",
    "I/We have signed and submitted the Declaration by Bidder acknowledging our acceptance of the auction rules and procedures.",
    "I/We have read and accepted the e-Auction Web Portal Disclaimer & Terms of Use, and understand the limitations and responsibilities of platform usage.",
  ];

  const [checkedTerms, setCheckedTerms] = useState(
    Array(termsList.length).fill(false)
  );
  const [error, setError] = useState(false);

  const toggleTerm = (index: number) => {
    const updated = [...checkedTerms];
    updated[index] = !updated[index];
    setCheckedTerms(updated);
  };

  const toggleAll = () => {
    const allChecked = checkedTerms.every(Boolean);
    setCheckedTerms(Array(termsList.length).fill(!allChecked));
  };

  const handleSubmit = async () => {
    setLoading(true);
    const allChecked = checkedTerms.every(Boolean);
    if (!allChecked) {
      setError(true);
    } else {
      setError(false);

      const data: any = await getBidderByUuid(bidderUuid);
      const res5: any = await updateBidderForEvent({
        uuid: bidderUuid,
        meta: {
          ...data?.meta,
          steps_status: {
            ...data?.meta?.steps_status,
            [outerNextStep === null ? "t_&_c" : outerNextStep]: "completed",
          },
        },
        verification_step: outerNextStep || "e-sign",
      });
      setActiveStep(activeStep + 1);
      await new Promise((resolve) => setTimeout(resolve, 1000));
      await init();
      setLoading(false);
      setError(false);
    }
    setLoading(false);
  };

  return (
    <div>
      <h2 className="text-xl font-semibold mb-4">Terms & Conditions</h2>
      <div>
        <p className="text-sm leading-6 mb-4 text-gray-700">
          I/We hereby confirm that I/We have read, understood, and agreed to the
          contents of each of the following sections, as provided in the Auction
          Notice, Bid Form, and related tender documents:
        </p>
      </div>
      <div className="space-y-3">
        {termsList.map((term, idx) => (
          <div key={idx} className="flex items-start space-x-3">
            <input
              type="checkbox"
              id={`term-${idx}`}
              checked={checkedTerms[idx]}
              onChange={() => toggleTerm(idx)}
              className="mt-1 h-4 w-4 text-brand-orange border-brand-orange rounded"
            />
            <label htmlFor={`term-${idx}`} className="text-sm text-gray-700">
              {term}
            </label>
          </div>
        ))}
      </div>

      <div className="mt-4">
        <label
          htmlFor="selectAll"
          className="text-sm font-medium  text-brand-headingBlue cursor-pointer"
          onClick={toggleAll}
        >
          Accept All Terms & Conditions
        </label>
      </div>
      {error && (
        <div className="text-sm text-red-600 font-medium">
          Please accept all Terms & Conditions to proceed.
        </div>
      )}
      <div className="mt-8 mb-10 md:mb-0">
        <Button
          className="w-full max-w-xl h-10 text-lg"
          onClick={handleSubmit}
          disabled={loading}
        >
          {loading ? "Processing..." : "Next"}
        </Button>
      </div>
    </div>
  );
}
